import { ShieldCheck, Users } from 'lucide-react';
import { Card } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';
import { usePermission } from '../../auth/model/usePermission.js';
import { Segmented, type SegmentedOption } from '../../../shared/ui/Segmented.js';

export type AccessView = 'staff' | 'roles';

export interface AccessSectionTabsProps {
  view: AccessView;
  onChange: (view: AccessView) => void;
}

/**
 * "Kirish huquqlari" bo'limining ikki ko'rinishi.
 *
 * XODIMLAR birinchi va standart: kundalik ish — odamga rol berish, uni olib
 * tashlash. Rollarning o'zini tahrirlash kamdan-kam, tizim sozlanayotgan
 * paytda bo'ladi.
 *
 * Segment RUXSAT bo'lsagina chiziladi: `user.read` va `rbac.role.manage`
 * alohida ruxsatlar bo'lib qoladi. Bo'limlarni birlashtirish ruxsatlarni
 * birlashtirmaydi.
 */
export const AccessSectionTabs = ({ view, onChange }: AccessSectionTabsProps) => {
  const { canAnywhere } = usePermission();

  const options: SegmentedOption<AccessView>[] = [];
  if (canAnywhere('user.read')) {
    options.push({
      value: 'staff',
      label: t('access.viewStaff'),
      icon: <Users size={15} aria-hidden />,
    });
  }
  if (canAnywhere('rbac.role.manage')) {
    options.push({
      value: 'roles',
      label: t('access.viewRoles'),
      icon: <ShieldCheck size={15} aria-hidden />,
    });
  }

  // Bitta ko'rinish qolsa almashgich ma'nosiz — tanlov yo'q joyda boshqaruv
  // ko'rsatish odamni "ikkinchisi qani?" deb qidirishga majbur qiladi.
  if (options.length < 2) return null;

  return (
    <Card padded={false} className="p-2">
      <Segmented
        label={t('access.viewLabel')}
        value={view}
        options={options}
        onChange={onChange}
      />
    </Card>
  );
};
